import { HeadingLevel, Paragraph, TabStopType, TextRun } from "docx";

export const methodology4_1 = new Paragraph({
    indent: { left: 1200 },
    spacing: { before: 550 },
    numbering: { reference: "my-crazy-numbering", level: 0 },
    tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
    children: [
        new TextRun({
            text: "Tools and Technologies Used ",
            size: 26,
            color: "0f0f3f",
            font: "Gill Sans MT",
            bold: true,
            italics: false,
            allCaps: false

        })
    ],
    heading: HeadingLevel.HEADING_3,
})



export const methodology4_2 = new Paragraph({
    indent: { left: 1200 },
    spacing: { before: 200 },
    numbering: { reference: "my-crazy-numbering", level: 0 },
    tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
    children: [
        new TextRun({
            text: "Weak Points",
            size: 26,
            color: "0f0f3f",
            font: "Gill Sans MT",
            bold: true,
            italics: false,
            allCaps: false

        })
    ],
    heading: HeadingLevel.HEADING_3,
})

export const methodology4_3 = new Paragraph({
    indent: { left: 1200 },
    spacing: { before: 550, after: 10 },
    numbering: { reference: "my-crazy-numbering", level: 0 },
    tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
    children: [
        new TextRun({
            text: "Strong Points",
            size: 26,
            color: "0f0f3f",
            font: "Gill Sans MT",
            bold: true,
            italics: false,
            allCaps: false

        })
    ],
    heading: HeadingLevel.HEADING_3,
})


export const methodology4_4 = new Paragraph({
    indent: { left: 1200 },
    spacing: { before: 550, after: 10 },
    numbering: { reference: "my-crazy-numbering", level: 0 },
    tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
    children: [
        new TextRun({
            text: "Observation Summary",
            size: 26,
            color: "0f0f3f",
            font: "Gill Sans MT",
            bold: true,
            italics: false,
            allCaps: false

        })
    ],
    heading: HeadingLevel.HEADING_3,
})

export const methodology4_5 = new Paragraph({
    indent: { left: 1200 },
    spacing: { before: 550, after: 10 },
    numbering: { reference: "my-crazy-numbering", level: 0 },
    tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
    children: [
        new TextRun({
            text: "Findings Summary",
            size: 26,
            color: "0f0f3f",
            font: "Gill Sans MT",
            bold: true,
            italics: false,
            allCaps: false

        })
    ],
    heading: HeadingLevel.HEADING_3,
})